import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { RequestReadState } from '@atlassian/notification-types/types';
import { ErrorBoundarySuspense } from '../../../../common/ui/error-boundary-suspense';
import { LazyFlag as LazyFlagSVG } from '../../../../common/ui/flag';
import { FormattedMessageBold } from '../../../../common/ui/formatted-message-bold';
import { triggerViewedAllNotificationsUIEvent, useCreateFireAnalyticsFromTrigger } from '../../../../common/utils/analytics';
import messages from '../../../../common/utils/i18n/messages';
import { CenterLayout, SmallSVGContainer, Text } from './styled';
export var NoMoreToLoad = function NoMoreToLoad(_ref) {
  var readStateFilter = _ref.readStateFilter,
    viewedCount = _ref.viewedCount;
  var fireViewedAllNotifications = useCreateFireAnalyticsFromTrigger(triggerViewedAllNotificationsUIEvent);
  useEffect(function () {
    fireViewedAllNotifications(viewedCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(CenterLayout, {
    "data-testid": "no-more-to-load"
  }, /*#__PURE__*/React.createElement(SmallSVGContainer, null, /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
    loadingFallback: /*#__PURE__*/React.createElement("svg", null),
    errorFallback: /*#__PURE__*/React.createElement("svg", null),
    subjectId: "flag"
  }, /*#__PURE__*/React.createElement(LazyFlagSVG, null))), /*#__PURE__*/React.createElement(Text, null, readStateFilter === RequestReadState.UNREAD ? /*#__PURE__*/React.createElement(FormattedMessageBold, {
    message: messages.readAllNotifications
  }) : /*#__PURE__*/React.createElement(FormattedMessage, messages.upToDateDescription)));
};